module.exports = __webpack_public_path__ + "01ed352d221c76a9826c0b49ae2383c7.glb";